import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Footer from '../Components/Footer';
import { fetchBlogBySlug } from '../data/blogs';
import './Blog.css';

function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    (async () => {
      const data = await fetchBlogBySlug(slug);
      if (active) { setBlog(data); setLoading(false); }
    })();
    return () => { active = false; };
  }, [slug]);

  const formatDate = (d) => {
    if (!d) return '';
    try {
      return new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch { return ''; }
  };

  return (
    <>
      <Navbar />
      <div className="blog-post" style={{ marginTop: '9rem' }}>
        {loading ? (
          <p className="blog-empty">Loading…</p>
        ) : !blog ? (
          <div className="blog-empty">
            <p>This post could not be found.</p>
            <button className="blogSeeAllBtn" onClick={() => navigate('/blog')}>Browse the Journal</button>
          </div>
        ) : (
          <article className="blog-article">
            {blog.category && <span className="blog-article-category">{blog.category}</span>}
            <h1 className="blog-article-title">{blog.title}</h1>
            <div className="blog-article-meta">
              {blog.author && <span>{blog.author}</span>}
              {blog.readTime && <span>· {blog.readTime}</span>}
              {blog.createdAt && <span>· {formatDate(blog.createdAt)}</span>}
            </div>

            {blog.image && (
              <div className="blog-article-cover">
                <img src={blog.image} alt={blog.title} />
              </div>
            )}

            {blog.excerpt && <p className="blog-article-lead">{blog.excerpt}</p>}

            <div className="blog-article-content">
              {String(blog.content || '')
                .split(/\n{2,}/)
                .filter((p) => p.trim())
                .map((para, i) => (
                  <p key={i}>{para.split('\n').map((line, j, arr) => (
                    <React.Fragment key={j}>{line}{j < arr.length - 1 ? <br /> : null}</React.Fragment>
                  ))}</p>
                ))}
            </div>
          </article>
        )}
      </div>
      <Footer />
    </>
  );
}

export default BlogPost;
